import React from 'react';
import { SuperEmojiCollection } from '../../utils/types';
import { SUPER_EMOJIS } from '../../services/superEmojiService';

export interface GameFooterProps {
  superEmojiCollection: SuperEmojiCollection;
  onSuperEmojiClick: (emoji: string) => void;
}

const GameFooter: React.FC<GameFooterProps> = ({ 
  superEmojiCollection,
  onSuperEmojiClick
}) => {
  return (
    <div className="game-footer">        
        <div className="super-emojis-center">
          {SUPER_EMOJIS.map((superEmoji) => {
            const count = superEmojiCollection[superEmoji.emoji] || 0;
            const isClickable = count > 0;
            
            return (
              <div 
                key={superEmoji.emoji}
                className={`super-emoji-item ${isClickable ? 'clickable' : ''}`}
                onClick={() => isClickable && onSuperEmojiClick(superEmoji.emoji)}
                title={`${superEmoji.name}: ${superEmoji.description} (${count} available)`}
              >
                <div className="super-emoji-count">
                  {count}
                </div>
                <div className="super-emoji-icon">
                  {superEmoji.emoji}
                </div>
              </div>
            );
          })}
        </div>
    </div>
  );
};

export default GameFooter;